// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5840a6da","732":"d8f90dbb","977":"ed9582f5"}[chunkId] + ".chunk.js";
};